import './PreventiveTools.scss';

import { useDispatch } from "react-redux";

import { openDrawer } from "../../../slices/drawerSlice";
import { openModal } from "../../../slices/modalSlice";

import FilterAlt from "@mui/icons-material/FilterAlt";
import FileDownload from "@mui/icons-material/FileDownload";

import { SearchBar } from "../../../common-components/SearchBar/SearchBar";
import { TextButton } from "../../../common-components/Buttons/Buttons";
import { IconButton } from "../../../common-components/Buttons/Buttons";

import PreventiveFilters from "../PreventiveFilters/PreventiveFilters";
import PreventiveFiltersFooter from "../PreventiveFilters/components/PreventiveFiltersFooter/PreventiveFiltersFooter";
import PreventiveFiltersTools from "../PreventiveFilters/components/PreventiveFiltersTools/PreventiveFiltersTools";
import PreventiveExportModal from "../../../components/preventive-export-modal/PreventiveExportModal";

const PreventiveTools = () => {
    const dispatch = useDispatch();

    const handleOpen = () => {
        dispatch(openDrawer({content: <PreventiveFilters/>, tools: <PreventiveFiltersTools/>, footer: <PreventiveFiltersFooter/>}))
    }

    const handleOpenModal = () => {
        dispatch(openModal({content: <PreventiveExportModal/>, closeable: true}));
    }

    return (
        <div className={"preventive-tools"}>
            <div className={"preventive-tools_container"}>
                <div className={"preventive-tools_search"}>
                    <SearchBar componentId={"preventive"}/>
                </div>
                <div className={"preventive-tools_desktop-buttons"}>
                    <TextButton Icon={FilterAlt} title={"Фильтры"} active={true} onClick={handleOpen}/>
                    <TextButton Icon={FileDownload} title={"Экспорт в Excel"} active={true} onClick={handleOpenModal}/>
                </div>
                <div className={"preventive-tools_mobile-buttons"}>
                    <IconButton Icon={FilterAlt} onClick={handleOpen}/>
                </div>
            </div>
        </div>
    )
}

export default PreventiveTools;